import React from 'react';
import { components } from 'react-select';
import Tooltipable from '~/components/effects/tooltipable';

const Control = ({ children, ...props }) => {
  const { tooltipText, tooltipPlacement, tooltipClassName } = props.selectProps;
  const control = <components.Control {...props}>{children}</components.Control>;

  return tooltipText ? (
    <Tooltipable text={tooltipText} placement={tooltipPlacement} className={tooltipClassName || "d-block"}>
      {control}
    </Tooltipable>
  ) : (
    control
  );
};

export default Control;
